<template>
  <inventoryProductsCategoriesForm :typeEndPoint="'inventoryProductsSubCategoriesShow'" :dataParams="this.$route.params" />
</template>
<script>
import inventoryProductsCategoriesForm from '@/components/modules/inventory/products/subcategories/form'
export default {
  name: 'inventoryProductsCategories',
  components: {
    inventoryProductsCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/inventory/products/subcategories/edit.vue